import { render } from "./MoneyEditor.vue?vue&type=template&id=7b026a06&ts=true"
import script from "./MoneyEditor.vue?vue&type=script&lang=ts"
export * from "./MoneyEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__